import type { SkeletonProps } from '@mui/material';
import { Skeleton, Grid2 } from '@mui/material';
import React from 'react';

interface SkeletonLoaderGridProps extends SkeletonProps {
  children?: React.ReactNode;
  loading: boolean;
  count?: number;
  itemWidth: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderGridProps> = ({
  children = null,
  loading = false,
  count = 1,
  variant = 'rounded',
  animation = 'wave',
  itemWidth,
  ...skeletonProps
}) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!loading) return <>{children}</>;

  return (
    <Grid2 container spacing={4} justifyContent="space-evenly">
      {Array.from(Array(count)).map((_key, index) => (
        <Grid2
          key={`skeleton-loader-${index}`}
          width="100%"
          maxWidth={itemWidth}
        >
          <Skeleton
            {...skeletonProps}
            animation={animation}
            variant={variant}
          />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default SkeletonLoader;
